import ConfigurationService from "@/services/configuration.service";

const VersionService = {
    isOldAppVersion() {
        const appMajorVersion = parseFloat(process.env.VUE_APP_API_MIN_VERSION);
        const apiMajorVersion = parseFloat(ConfigurationService.get('app.minimumSupportedVersion'));

        // If major version is greater than current version redirect to old version page
        return appMajorVersion < apiMajorVersion;
    },

    async isOldAppData() {
        let appDataVersion = ConfigurationService.getConfiguration()?.data?.currentVersion ?? null;
        let apiDataVersion = null;

        if(appDataVersion === null) {
            appDataVersion = apiDataVersion = await ConfigurationService.loadRemoteConfiguration(true);
        } else {
            apiDataVersion = await ConfigurationService.loadRemoteConfiguration();
        }

        return parseFloat(appDataVersion) < parseFloat(apiDataVersion.data.currentVersion);
    }
};

export {VersionService};